import { I18n } from "@assets/strings";
import React, { useState } from "react";
import styled from "styled-components";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { SecondaryButton } from "@ui/components/buttons/secondaryButton";
import { Secondary } from "@ui/components/containers/textBlocks";
import { gap, mobile } from "@ui/styles/utils";
import { ClosableModal, ClosableModalProps } from "./closableModal";

interface ConfirmationModalProps extends Omit<ClosableModalProps, "close"> {
	close: (confirm?: boolean) => void;
	cancelLabel?: string;
	confirmLabel?: string;
	message?: string;
}
export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
	close,
	cancelLabel,
	confirmLabel,
	children,
	message,
	...htmlProps
}) => {
	const [loading, setLoading] = useState(false);

	return (
		<Container close={() => close(false)} {...htmlProps}>
			{children}
			{message && <Secondary>{message}</Secondary>}
			<Actions>
				<SecondaryButton onClick={() => close(false)}>{cancelLabel ?? I18n.t("cancel")}</SecondaryButton>
				<LoadingButton
					loading={loading}
					onClick={() => {
						setLoading(true);
						close(true);
					}}
				>
					{confirmLabel ?? I18n.t("validate")}
				</LoadingButton>
			</Actions>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${gap(25)};
	align-items: center;
	text-justify: center;
	align-content: justify;
`;

const Actions = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	margin-top: 40px;
	${gap(25, "row")};

	@media ${mobile} {
		${gap(15, "row")};
		> button {
			padding: 12px 20px;
		}
	}
`;
